import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-clock-04',
  standalone: true,
  templateUrl: '../../assets/clock-04.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamClock04Icon {}
